import React from 'react';
import './styles.css';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: { value: string | number; label: string }[];
  emptyMessage?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = '', options, emptyMessage, ...props }, ref) => {
    const selectClasses = `select ${className}`.trim();
    return (
      <select className={selectClasses} ref={ref} {...props}>
        {options.length === 0 ? (
          <option value="" disabled>{emptyMessage || 'Nenhum item encontrado'}</option>
        ) : (
          <>
            <option value="">Selecione...</option>
            {options.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </>
        )}
      </select>
    );
  }
);

Select.displayName = 'Select';
